"use client";
import { lazy, Suspense } from "react";
import type { EditorProps } from "@monaco-editor/react";

const MonacoEditor = lazy(() => import("@monaco-editor/react"));

type MonacoEditorPaneProps = {
  beforeMount: NonNullable<EditorProps["beforeMount"]>;
  path: string;
  language: string;
  theme: string;
  value: string;
  onChange: NonNullable<EditorProps["onChange"]>;
  options: NonNullable<EditorProps["options"]>;
};

export function MonacoEditorPane({
  beforeMount,
  path,
  language,
  theme,
  value,
  onChange,
  options,
}: MonacoEditorPaneProps) {
  return (
    <Suspense
      fallback={
        <div className="p-4 text-sm text-muted-foreground">
          Loading editor...
        </div>
      }
    >
      <MonacoEditor
        beforeMount={beforeMount}
        path={path}
        language={language}
        theme={theme}
        value={value}
        onChange={onChange}
        options={options}
        loading={
          <div className="p-4 text-sm text-muted-foreground">
            Loading editor...
          </div>
        }
        height="100%"
      />
    </Suspense>
  );
}
